var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 72,
    viewBox: "0 0 203 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8649 44.5101C40.8649 47.799 39.6589 50.622 37.2745 52.9791C34.89 55.3361 32.0122 56.4872 28.641 56.4872H12.2238C8.85268 56.4872 5.97488 55.3087 3.59041 52.9791C1.20594 50.622 0 47.799 0 44.5101V17.212C0 16.0883 0.520746 15.5402 1.61705 15.5402H6.55044C7.61934 15.5402 8.16749 16.0883 8.16749 17.212V44.4279C8.16749 45.716 8.57861 46.8123 9.37343 47.7168C10.1683 48.6487 11.1275 49.1146 12.2512 49.1146H28.6684C29.7922 49.1146 30.724 48.6487 31.5462 47.7168C32.3411 46.7849 32.7522 45.6886 32.7522 44.4279V24.5573C32.7522 23.4336 33.2729 22.8854 34.3692 22.8854H39.3026C40.3715 22.8854 40.9197 23.4336 40.9197 24.5573V44.5101H40.8649Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4705 34.9448V37.0552C84.4157 38.3982 84.7994 39.4945 85.6216 40.3989C86.4164 41.3034 87.4031 41.7693 88.5542 41.7693H104.917C106.04 41.7693 106.972 41.3034 107.794 40.3989C108.589 39.4945 109 38.3708 109 37.0552V27.6818C109 26.3662 108.589 25.2425 107.794 24.3106C107 23.3788 106.04 22.9128 104.917 22.9128H88.5542C85.1283 22.9128 82.2505 21.7343 79.8386 19.3772C77.4541 17.0202 76.2482 14.1698 76.2482 10.826V5.83784L76.303 1.67187C76.303 0.548154 76.8512 0 77.9201 0H82.8534C83.9223 0 84.4705 0.548154 84.4705 1.67187L84.4157 5.83784V10.8534C84.4157 12.169 84.8268 13.2927 85.6216 14.1972C86.4164 15.1016 87.4031 15.5676 88.5542 15.5676H104.917C108.288 15.5676 111.166 16.7461 113.55 19.1032C115.935 21.4602 117.14 24.3106 117.14 27.6544V37.0278C117.14 40.3715 115.935 43.2219 113.55 45.579C111.166 47.936 108.288 49.1146 104.917 49.1146H88.5542C85.1283 49.1146 82.2505 47.936 79.8386 45.579C77.4541 43.2219 76.2482 40.3715 76.2482 37.0278V34.9448H84.4705Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.239 44.9486C159.239 48.2375 158.06 50.9783 155.703 53.1983C153.346 55.3909 150.441 56.4872 147.042 56.4872H130.735C127.364 56.4872 124.486 55.3087 122.101 52.9517C119.717 50.5946 118.511 47.7442 118.511 44.4005C118.511 41.0293 119.717 38.1515 122.101 35.767C124.486 33.3826 127.364 32.1766 130.735 32.1766H149.756C150.66 32.1766 151.126 31.7107 151.126 30.8062V27.6544C151.126 26.3662 150.715 25.2699 149.92 24.3106C149.125 23.3514 148.166 22.8854 147.042 22.8854H128.706C128.213 22.8854 127.747 22.6936 127.309 22.255C126.87 21.8439 126.651 21.378 126.651 20.8847V17.5957C126.651 17.1298 126.87 16.6913 127.336 16.2254C127.802 15.7594 128.241 15.5402 128.706 15.5402H147.042C150.413 15.5402 153.291 16.7461 155.676 19.158C158.06 21.5699 159.266 24.4477 159.266 27.764V44.9486H159.239ZM151.071 44.9486V41.0019C151.071 40.0975 150.605 39.6315 149.701 39.6315H130.68C129.556 39.6315 128.624 40.0975 127.802 41.0293C127.007 41.9612 126.596 43.0849 126.596 44.4005C126.596 45.6886 127.007 46.7849 127.802 47.7442C128.597 48.7035 129.556 49.1694 130.68 49.1694H146.987C148.139 49.1694 149.098 48.7857 149.893 48.0183C150.687 47.2234 151.071 46.2094 151.071 44.9486Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.899 30.5048C202.899 31.6285 202.351 32.1766 201.255 32.1766H196.403C195.307 32.1766 194.759 31.6285 194.759 30.5048V27.627C194.759 26.3114 194.348 25.1877 193.553 24.2832C192.758 23.3788 191.772 22.9128 190.675 22.9128H174.231C173.08 22.9128 172.093 23.3788 171.325 24.2832C170.531 25.1877 170.147 26.3114 170.147 27.627V54.8154C170.147 55.9391 169.599 56.4873 168.502 56.4873H163.624C162.528 56.4873 161.979 55.9391 161.979 54.8154V27.6544C161.979 24.3106 163.185 21.4602 165.57 19.1032C167.954 16.7461 170.86 15.5676 174.285 15.5676H190.648C194.019 15.5676 196.924 16.7461 199.309 19.1032C201.721 21.4602 202.926 24.3106 202.926 27.6544V30.5048H202.899Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1918 49.0872H55.8295C54.7057 49.0872 53.7739 48.6212 52.9517 47.6894C52.1568 46.7575 51.7457 45.6338 51.7457 44.3182V34.9448C51.7457 33.6292 52.1568 32.5055 52.9517 31.6011C53.7465 30.6966 54.7057 30.2307 55.8295 30.2307H72.1918C73.343 30.2307 74.3296 30.6966 75.1245 31.6011C75.9193 32.5055 76.2756 33.6292 76.2756 34.9448C76.2756 36.0685 76.7963 36.6167 77.8926 36.6167H82.8534C83.7305 36.6167 84.306 37.0004 84.4979 37.7952V34.9996C84.4979 31.6559 83.292 28.8055 80.9075 26.4484C78.523 24.0914 75.6178 22.9128 72.1918 22.9128H55.8295C52.4583 22.9128 49.5805 24.0914 47.196 26.4484C44.8116 28.8055 43.6056 31.6559 43.6056 34.9996V44.3456C43.6056 47.6894 44.8116 50.5398 47.196 52.8968C49.5805 55.2539 52.4583 56.4324 55.8295 56.4324H72.1918C73.343 56.4324 74.3296 56.8984 75.1245 57.8028C75.9193 58.7073 76.3304 59.831 76.3304 61.1465V66.1622L76.2756 70.3281C76.2756 71.4518 76.7963 72 77.8926 72H82.826C83.8949 72 84.4431 71.4518 84.4431 70.3281L84.4979 66.1622V61.2014C84.4979 57.8576 83.292 55.0072 80.9075 52.6502C78.4956 50.2657 75.5904 49.0872 72.1918 49.0872Z",
    fill: "url(#paint4_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.4312,
    y1: 56.4788,
    x2: 20.4312,
    y2: 15.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 96.6899,
    y1: 49.1335,
    x2: 96.6899,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 118.492,
    y1: 36.0167,
    x2: 159.231,
    y2: 36.0167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 161.972,
    y1: 36.0168,
    x2: 202.896,
    y2: 36.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 43.6032,
    y1: 47.4483,
    x2: 84.4792,
    y2: 47.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302F3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.899,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dcefccab33b896e3a9a314dde2b92409.svg";
export { ForwardRef as ReactComponent };